import { render, staticRenderFns } from "./dashboard_brandwise.vue?vue&type=template&id=478ef017"
import script from "./dashboard_brandwise.vue?vue&type=script&lang=js"
export * from "./dashboard_brandwise.vue?vue&type=script&lang=js"
import style0 from "./dashboard_brandwise.vue?vue&type=style&index=0&id=478ef017&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports